import { Email, Phone } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { BooleanTag, StateTag } from "@msuite/ui/tag";
import { guardString } from "@msuite/utils/strings";
import type { OrganizationMember } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

export const columnHelper = createColumnHelper<OrganizationMember>();

export const columns = [
	columnHelper.accessor("user.firstName", {
		id: "fullName",
		header: localized("profile.first_name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("user.lastName", {
		id: "lastName",
		header: localized("profile.last_name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("user.email", {
		id: "email",
		header: localized("personnel.fields.email"),
		cell: (cell) => <Email>{guardString(cell.getValue())}</Email>,
	}),
	columnHelper.accessor("user.phone", {
		id: "phone",
		header: localized("personnel.fields.phone"),
		cell: (cell) => <Phone>{guardString(cell.getValue())}</Phone>,
	}),
	columnHelper.accessor("membership.state", {
		id: "state",
		header: localized("general.state"),
		cell: (cell) => <StateTag state={cell.getValue()} />,
	}),
	columnHelper.accessor("user.emailVerified", {
		id: "emailVerified",
		header: localized("users.email_verified"),
		cell: (cell) => <BooleanTag value={cell.getValue()} />,
	}),
	createRowActions(RowActions),
];
